<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {contacts, requisites} from "@js/company_details.ts";
import {formatPhone} from "@js/helpers.ts";
import {Link} from "@inertiajs/vue3";

export default {
    name: "PublicOfferPage",
    components: {Link, MobileTopBar, Breadcrumbs},
    setup() {
        return {contacts, requisites, formatPhone};
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs class="mb-2"/>
        <h1 class="text-2xl md:text-3xl">Публичная оферта ООО «Дорожные плиты»</h1>
        <p class="text-sm text-gray-600 mt-2">Действует для сайта dorozhnyeplity.ru</p>
        <hr class="mt-5 mb-5"/>

        <!-- Основные понятия -->
        <div class="mb-10">
            <h2 class="text-xl font-medium mb-5">Основные понятия</h2>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Посетитель Сайта</span> — лицо, пришедшее на сайт <strong>https://dorozhnyeplity.ru</strong> без цели размещения Заказа.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Пользователь</span> — физическое лицо, посетитель Сайта, принимающий условия настоящей Оферты и желающий разместить Заказ.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Покупатель</span> — Пользователь или юридическое лицо, разместившее Заказ через Сайт или по телефону/электронной почте.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">ООО «Дорожные плиты»</span> — Продавец, ИНН {{ requisites.inn }}, КПП {{ requisites.kpp }}, ОГРН {{ requisites.ogrn }}.
            </p>
            <p class="text-sm mb-2"><span class="font-bold text-base">Юридический адрес:</span> {{ requisites.ur_address }}</p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Интернет-магазин</span> — сайт <strong>https://dorozhnyeplity.ru</strong>, где размещены товары, условия оплаты и доставки.
            </p>
            <p class="text-sm mb-2"><span class="font-bold text-base">Сайт</span> — <strong>https://dorozhnyeplity.ru</strong></p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Товар</span> — железобетонные изделия (ЖБИ) и бетонные смеси: дорожные плиты (ПДН/ПАГ), плиты перекрытий (ПК/ПБ), блоки ФБС, бортовые камни (БР), лотки ЛК/Л, кольца КС и доборные элементы, перемычки ПБ/ПП, сваи СВ, лестничные марши и площадки, а также бетонные и растворные смеси марок М100–М400 (классы В7,5–В30) с требуемыми характеристиками подвижности (П1–П5), морозостойкости (F), водонепроницаемости (W), добавками.
            </p>
            <p class="text-sm mb-2"><span class="font-bold text-base">Заказ</span> — оформленный запрос на покупку и поставку Товара по адресу Покупателя либо самовывозом.</p>
        </div>

        <!-- 1. Общие положения -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">1. Общие положения</h2>
            <p class="text-sm mb-2">1.1. Продавец осуществляет продажу Товаров через Интернет-магазин по адресу <strong>https://dorozhnyeplity.ru</strong>.</p>
            <p class="text-sm mb-2">
                1.2. Размещая Заказ, Пользователь соглашается с условиями настоящей Публичной оферты. В случае несогласия Пользователь обязан прекратить использование сервиса.
            </p>
            <p class="text-sm mb-2">1.3. Настоящий документ является публичной офертой по ст. 435 и п. 2 ст. 437 ГК РФ.</p>
            <p class="text-sm mb-2">1.4. Редакция Оферты может изменяться Продавцом в одностороннем порядке. Новая редакция действует с момента публикации, если не указано иное.</p>
            <p class="text-sm mb-2">
                1.5. Акцепт Оферты — регистрация на Сайте, оформление Заказа (включая без авторизации), либо подтверждение Заказа по телефону {{ formatPhone(contacts.sales_department_phone) }} или e‑mail {{ contacts.info_mail }}. Договор считается заключённым с момента выдачи кассового/товарного чека или иного документа, подтверждающего оплату.
            </p>
            <p class="text-sm mb-2">1.6. Продавец вправе поручить исполнение обязательств третьим лицам, оставаясь ответственным перед Покупателем.</p>
            <p class="text-sm mb-2">1.7. Цены и наличие на Сайте ориентировочные до подтверждения менеджером. Счёт/КП действительно ограниченный срок (обычно 1 рабочий день) из‑за колебаний рынка.</p>
        </div>

        <!-- 2. Регистрация -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">2. Регистрация на Сайте</h2>
            <p class="text-sm mb-2">2.1. Регистрация не обязательна для оформления Заказа.</p>
            <p class="text-sm mb-2">2.2. Пользователь несёт ответственность за корректность предоставленных данных и сохранность учётных данных. При подозрении на компрометацию уведомите нас: {{ contacts.info_mail }}.</p>
        </div>

        <!-- 3. Товар и покупка -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">3. Товар и порядок совершения покупки</h2>
            <p class="text-sm mb-2">3.1. Изображения носят иллюстративный характер и могут отличаться от фактического вида Товара. Описания и характеристики ориентировочные и могут содержать опечатки.</p>
            <p class="text-sm mb-2">3.2. При отсутствии Товара на складе Продавец вправе изменить/аннулировать Заказ с уведомлением Покупателя по e‑mail.</p>
            <p class="text-sm mb-2">3.3. При аннуляции предоплаченного Заказа возврат денежных средств осуществляется тем же способом.</p>
            <p class="text-sm mb-2">3.4. Масса/объём принимаются по факту при отгрузке согласно документам. Допуски и отклонения — по ГОСТ/ТУ.</p>
            <p class="text-sm mb-2">3.5. Услуги индивидуальной обработки (резка, сверление, сварка, гибка, окраска, грунтование) и изготовление под размеры Покупателя возврату не подлежат.</p>
            <p class="text-sm mb-2">3.6. По бетону: отпуск в м³ (кубах); допускаются технологические отклонения по объёму/подвижности в пределах норм. Требования по П/F/W и добавкам согласуются до отгрузки; бетононасос/подача — отдельная услуга.</p>
            <p class="text-sm mb-2">3.7. Сертификаты/паспорта качества предоставляются при наличии у производителя/склада.</p>
        </div>

        <!-- 4. Доставка -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">4. Доставка заказа</h2>
            <p class="text-sm mb-2">
                4.1. Способы доставки указаны в разделе «Доставка»:
                <Link :href="route('deliveryAndShipping')" class="underline hover:text-navHoverColor leading-tight transition font-bold">
                    dorozhnyeplity.ru/delivery-and-shipping
                </Link>.
            </p>
            <p class="text-sm mb-2">4.2. Территория доставки — Москва и МО; в регионы РФ — через транспортные компании. Продавец не несёт ответственности за услуги сторонних перевозчиков.</p>
            <p class="text-sm mb-2">4.3. Стоимость доставки рассчитывается индивидуально исходя из габаритов, массы/объёма, удалённости, способа разгрузки и формы оплаты.</p>
            <p class="text-sm mb-2">4.4. Разгрузка организуется силами Покупателя, если иное не согласовано. Кран/манипулятор/погрузчик — отдельные услуги. Пропуска, доступ на объект — ответственность Покупателя.</p>
            <p class="text-sm mb-2">4.5. Риск случайной гибели/повреждения переходит к Покупателю с момента передачи Товара перевозчику (или Получателю при собственной доставке Продавца).</p>
            <p class="text-sm mb-2">4.6. Простоевое время транспорта на разгрузке ограничено; простой оплачивается по тарифу.</p>
        </div>

        <!-- 5. Оплата -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">5. Оплата товара</h2>
            <p class="text-sm mb-2">Цены указываются в рублях РФ и могут включать НДС (указано в счёте). Доступны: безналичная оплата по счёту (юр/физ лица), оплата банковской картой (при наличии), наличными при самовывозе/доставке (если предусмотрено).</p>
            <p class="text-sm mb-2">Цена подтверждённого Заказа не меняется, кроме случаев истечения срока действия счёта/КП до оплаты либо изменения спецификации по инициативе Покупателя.</p>
            <p class="text-sm mb-2 font-bold">5.1. Особенности оплаты банковскими картами (при доступности):</p>
            <p class="text-sm mb-2">5.1.1. Банк-эмитент вправе отказать при подозрении на мошенничество; возможна дополнительная верификация личности.</p>
            <p class="text-sm mb-2">5.1.2. Акции/скидки/бонусы устанавливаются Продавцом и могут изменяться.</p>
            <p class="text-sm mb-2">5.2. Счёт/КП действительно ограниченный срок (обычно 1 рабочий день) из‑за рыночных колебаний.</p>
        </div>

        <!-- 6. Возврат -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">6. Возврат товара и денежных средств</h2>
            <p class="text-sm mb-2">6.1. Приёмка по количеству/ассортименту/комплектности осуществляется при отгрузке/получении и фиксируется актом при участии представителя перевозчика/Продавца.</p>
            <p class="text-sm mb-2">6.2. Товар надлежащего качества подлежит возврату/обмену в течение 7 дней при сохранении товарного вида, упаковки/обвязки, маркировки, документов. Возврат — силами и за счёт Покупателя.</p>
            <p class="text-sm mb-2">6.3. Не подлежат возврату: Товары индивидуальной обработки/изготовления; бетонные смеси и растворы.</p>
            <p class="text-sm mb-2">6.4. При отказе от Товара возврат средств производится за вычетом расходов на доставку и фактических затрат в течение 10 дней после получения заявления и Товара.</p>
        </div>

        <!-- 7. Ответственность -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">7. Ответственность</h2>
            <p class="text-sm mb-2">Продавец не отвечает за ущерб, причинённый ненадлежащим использованием Товара. За работу внешних сайтов и качество Товара сторонних продавцов ответственность не несём.</p>
        </div>

        <!-- 8. Конфиденциальность -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">8. Конфиденциальность и защита информации</h2>
            <p class="text-sm mb-5">Персональные данные обрабатываются согласно ФЗ № 152‑ФЗ «О персональных данных». Предоставляя данные, Пользователь соглашается на их обработку для исполнения договора, логистики, клиентской поддержки и информирования. Отказ от рекламных сообщений — по телефону {{ formatPhone(contacts.sales_department_phone) }} или на e‑mail {{ contacts.info_mail }}. Сервисные уведомления (о заказе) направляются независимо от согласия.</p>
            <p class="text-sm mb-2">8.1. На Сайте используются cookies и может фиксироваться IP‑адрес. Запись телефонных разговоров допустима в целях повышения качества сервиса.</p>
        </div>

        <!-- 9. Срок действия -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">9. Срок действия Публичной оферты</h2>
            <p class="text-sm mb-2">Оферта действует с момента акцепта и до его отзыва Покупателем, если иное не предусмотрено договором/законом.</p>
        </div>

        <!-- 10. Дополнительные условия -->
        <div>
            <h2 class="text-xl mb-5 font-medium">10. Дополнительные условия</h2>
            <p class="text-sm mb-2">Продавец вправе уступать права и переводить обязанности третьим лицам. Сервис может быть временно недоступен по техническим причинам. Применяется законодательство РФ. Споры — путём переговоров, при недостижении соглашения — в судебном порядке. Недействительность отдельного условия не влечёт недействительность остальных.</p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.prose a {
    @apply text-yellow-600 hover:text-yellow-800 underline;
}
</style>
